import type React from "react";

import { classList } from "~lib/classList.ts";

import styles from "./Divider.module.scss";

export interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  strokeWidth?: number;
  strokeDashSize?: number;
  strokeGap?: number;
}

export function Divider({
  strokeWidth = 2,
  strokeDashSize = 5,
  strokeGap = 5,
  className,
  ...props
}: DividerProps) {
  return (
    <div
      {...props}
      className={classList(styles.container, className)}
      style={{
        height: `${strokeWidth + 1}px`,
        borderRadius: `${strokeWidth}px`,
      }}
    >
      <svg
        className={styles.divider}
        viewBox={`0 0 100 ${strokeWidth}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Divider</title>
        <line
          y1={strokeWidth / 2}
          x1="0%"
          x2="100%"
          y2={strokeWidth / 2}
          strokeWidth={strokeWidth}
          stroke="black"
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeDasharray={`${strokeDashSize * strokeWidth} ${
            strokeGap * strokeWidth
          }`}
        />
      </svg>
    </div>
  );
}
